import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type SessionContextService from 'tio-employee/services/session-context';
import type { AuthenticatedSyfRouteModel } from '../../syf';
import type { PersonExtension as PersonModel } from 'tio-data/data/resources/person.ext';

export default class AuthenticatedSyfPaymentsNewRoute extends Route {
  @service declare store: Store;
  @service declare sessionContext: SessionContextService;

  async model() {
    const { content } = (await this.store.request(
      findRecord<PersonModel>('person', this.sessionContext.user.person.id!, {
        include: 'accounts',
        reload: true,
      })
    )) as { content: { data: PersonModel } };
    const person = content.data;

    const parentModel = this.modelFor('authenticated.syf') as AuthenticatedSyfRouteModel;
    const matchParticipant = parentModel.matchParticipant;

    return {
      matchParticipant,
      accounts: person.activeAccounts,
    };
  }
}
